/* eslint-disable id-length */
/**
 * General api script class
 *
 * @package    Api
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

export default class GeneralApi {
    /**
     * Send request for load airports
     *
     * @param {String} search - Search string
     */
    static loadAirports (search) {
        return (axios) => axios.get('/ribyt/rsvp/searchAirports/', {
            params: {
                q: search,
            },
        });
    }
}
